/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Atrás",
      "<h3 class=”header-3”>Estado de accesibilidad</h3> <p>La Ley Europea de Accesibilidad nos exige diseñar nuestros servicios de comercio electrónico (incluidos los métodos de identificación y pago) teniendo en cuenta la accesibilidad, de modo que sean perceptibles, operables, comprensibles y robustos. Además, nos esforzamos por diseñar nuestros sitios web y aplicaciones móviles de acuerdo con las <a href=\"https://www.w3.org/WAI/standards-guidelines/wcag/\" target=\"_blank\">Pautas de accesibilidad de contenido web 2.1 de Nivel AA de W3C</a>. Para lograr estos objetivos, hemos hecho lo siguiente: </p> <ul> <li>Nos hemos asociado con consultorías de accesibilidad como Level Access para comprender cómo podemos hacer que nuestros servicios sean más accesibles.</li> <li>Hemos evaluado nuestras experiencias digitales según las normas de accesibilidad globales.</li> <li>Hemos aprendido de un equipo diverso de expertos en accesibilidad, incluidos usuarios con discapacidades y necesidades de accesibilidad adicionales.</li> </ul>",
      "<h3 class=”header-3”>Comentarios y contacto</h3> <p>Mientras nos esforzamos por garantizar la accesibilidad para todos los usuarios, es posible que existan algunas limitaciones. Nos encantaría recibir tus comentarios para ayudarnos a mejorar, así que si te encontrás con alguna barrera de accesibilidad o necesitás información en un formato alternativo, comunicate con accessibility@bumble.com.</p>",
      "<h3 class=”header-3”>Mejoras futuras</h3> <p>Nuestro trabajo de accesibilidad es continuo. Seguiremos:</p> <ul> <li>Monitoreando y revisando la accesibilidad en todas las plataformas digitales.</li> <li>Corrigiendo problemas conocidos y previniendo nuevas barreras mediante el diseño pensado para la accesibilidad.</li> <li>Expandiendo el entrenamiento y la concientización internos para mejorar las prácticas de diseño inclusivo.</li> </ul>",
      "<h3 class=”header-3”>Última actualización: Noviembre del 2025</h3>",
      "<h3 class=”header-3”>Medidas adoptadas</h3> <p>Para lograr la accesibilidad en nuestros servicios, hemos hecho lo siguiente:</p> <ul> <li>Nos hemos asociado con Level Access para realizar evaluaciones y orientación de accesibilidad exhaustivas.</li> <li>Hemos integrado herramientas de accesibilidad en nuestras plataformas, incluidas tecnologías de asistencia como alternativas de teclado, habilitación de voz y navegación sin contacto.</li> <li>Hemos realizado pruebas de usuario con personas con discapacidad para obtener comentarios reales e informar mejoras.</li> <li>Hemos integrado consideraciones de accesibilidad en nuestro ciclo de vida de desarrollo de productos y procesos de garantía de calidad.</li> <li>Hemos establecido un programa de accesibilidad digital en toda la organización.</li> <li>Hemos implementado una <a href=\"https://www.levelaccess.com/bumble/\" target=\"_blank\">plataforma de experiencia de clientes de asistencia</a>. Esto es gratuito y está disponible para personas que tienen dificultades para escribir, gesticular, mover el mouse o leer. Incorpora herramientas como reemplazos de mouse y teclado, reconocimiento de voz, habilitación de voz, navegación con manos libres o sin interacción y mucho más.</li> </ul>",
      "<h3 class=”header-3”>Nuestra política</h3> <p>En Bumble, la igualdad está en el corazón de nuestros valores. Es mucho más que una palabra de moda para nosotros, nos esforzamos por hacer que las experiencias de Bumble sean accesibles, justas y equitativas.</p> <p>Esta declaración de accesibilidad se ha preparado para informar a nuestros usuarios sobre la accesibilidad de nuestro servicio, incluida su alineación con las normas legales y técnicas relevantes. Esta declaración de accesibilidad se aplica a los elementos de nuestros servicios [RS2] cubiertos por la Ley Europea de Accesibilidad, en particular, nuestros servicios de comercio electrónico, que permiten a los usuarios actualizarse a una gama de funciones mejoradas y premium de Bumble. Estos servicios se pueden acceder a través de la aplicación de Bumble.</p>",
      "Declaración de accesibilidad de EAA",
      "Descargar en la App Store",
      "Descargar en Google Play",
      "Carrusel",
      "Diapositiva {{number}}",
      "Próxima diapositiva",
      "Diapositiva anterior",
      "Diapositiva",
      "Diapositiva {{number}} de {{total}}",
      "No vender o compartir mi información personal",
      "No vender o compartir mi información personal",
      "Enviá Compliments en Bumble para que sepan que te gusta su perfil y llamá su atención antes de conectar. ¡Probá ahora!",
      "Compliments | Cómo enviar un Compliment | Bumble",
      "Una página personalizada que destaca a las personas más compatibles con vos, actualizada todos los días.",
      "Descubrí | Encontrá personas compatibles | Bumble",
      "Salí con alguien a tu propio ritmo y controlá quién ve tu perfil de Bumble con el Modo Incógnito. Para saber cómo usar el Modo Incógnito en Bumble, consultá nuestra guía.",
      "Modo Incógnito | Ocultá tu perfil | Bumble",
      "Después de conocerse en persona en un evento de Bumble y despertar la química entre ustedes, pasen a la app para seguir conversando.",
      "Conexión inmediata | Seguí chateando por la app | Bumble",
      "¿Necesitás un descanso o un tiempo para vos? Descubrí cómo poner en pausa tu cuenta de Bumble con el Modo No Molestar de Bumble. Conocé gente a tu manera.",
      "Modo No Molestar | Poné en pausa tu cuenta | Bumble",
      "¿Acabás de ver a alguien que te encanta en Bumble? Usá SuperSwipe para mostrarle tu interés. Tocá la estrella en su perfil para empezar, o mirá más detalles acá.",
      "SuperSwipe de Bumble | ¿Qué es un SuperSwipe? | Bumble",
      "¿De viaje por trabajo o diversión? Con el Modo Travel en Bumble podés hacer nuevas conexiones divertidas en un lugar nuevo y salir con gente donde quieras. Descubrí el Modo Travel acá.",
      "Modo Travel de Bumble | Salí donde quieras | Bumble",
      "¿Querés saber si la conexión que tienen por mensaje es real? Probá hacer una videollamada o una llamada de voz en Bumble ahora y sacate la duda.",
      "Videollamada | Hacé un llamada | Bumble",
      "Bumble Date",
      "Nuestras aplicaciones",
      "Sobre nosotros",
      "Empleo",
      "Contacto",
      "Inversores",
      "Nuestra Tienda",
      "Empresa",
      "Descargar la aplicación",
      "Accesibilidad en Bumble",
      "Normas",
      "Gestionar cookies",
      "Ley de esclavitud moderna",
      "Aviso de recopilación",
      "Política de privacidad",
      "Términos y condiciones",
      "Legal",
      "Política de privacidad de datos de salud del consumidor de Washington",
      "Escaneá el código QR para conseguir la app de Bumble",
      "Iniciar sesión",
      "Terminar contratos acá",
      "Descargar ahora",
      "Solo escaneá el código QR para empezar.",
      "¡Encontrá a tu próxima conexión!",
      "Descargá la aplicación",
      "Página principal de Bumble",
      "Cerrá el menú",
      "Abrí el menú",
      "Próximamente: Historias de amor de Bumble",
      "Elegí tu idioma",
      "Selección de idioma",
      "Pie de página",
      "Accesibilidad en Bumble",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Empleo",
      "Eventos",
      "Google Play es una marca de Google LLC.",
      "Reglas",
      "Inversores",
      "Gestionar cookies",
      "Gestionar cookies",
      "Declaración sobre la Modern Slavery Act",
      "Aviso de recopilación",
      "Política de privacidad",
      "Consejos sobre citas por temporada",
      "Condiciones de Uso",
      "La aplicación",
      "Política de privacidad de datos de salud del consumidor de Washington",
      "Acerca de",
      "Embajadores",
      "Hacé nuevas amistades y encontrá tu comunidad",
      "Generá una red de contactos y avanzá en tu carrera profesional",
      "Encontrá una relación, un vínculo casual o algo intermedio",
      "The Buzz",
      "¡Enterate!",
      "Globalizate con el Modo Travel",
      "Cita",
      "Eventos",
      "Funciones",
      "Compliments",
      "Sorprendé con tus Compliments y marcá la diferencia",
      "Descubrí",
      "Una página personalizada que destaca a las personas más compatibles con vos, actualizada todos los días.",
      "Modo Incógnito",
      "Usá el Modo Incógnito para ocultar tu perfil de tu jefe, familiares o exparejas.",
      "Conexión inmediata",
      "¿Arrancaste la charla en persona en un evento de Bumble? Seguila por la app.",
      "Modo No Molestar",
      "Usa el Modo no molestar para tomarte un tiempo. Cuando quieras volver a conocer gente nueva, te esperamos.",
      "SuperSwipe",
      "Si te gustó mucho un perfil, dejá que se sepa gracias a SuperSwipe.",
      "Travel",
      "Encontrá lo que te hace feliz en cualquier lugar del mundo y conectá con gente de todas partes con el Modo travel.",
      "Videollamada",
      "Usá la videollamada y las llamadas de audio para ver si estás listo para que se conozcan en persona.",
      "Conseguí la app de Bumble",
      "BFF",
      "Seguridad",
      "Historias",
      "Asistencia",
      "Nuestra Tienda",
      "Navegación principal",
      "Sorprendé con tus Compliments y marcá la diferencia.",
      "Compliments",
      "Funciones diseñadas para crear un espacio para conexiones reales, respetuosas y profundas.",
      "Ocultá tu perfil de tu jefe, familiares o exparejas.",
      "Modo Incógnito",
      "Usá el Modo No Molestar para tomarte un tiempo.",
      "Modo No Molestar",
      "¿Viste a alguien que te gusta? Que se entere ahora mismo.",
      "SuperSwipe",
      "Explorar la sección Cita",
      "Encontrá lo que te hace feliz y conectá en cualquier lugar.",
      "Modo Travel",
      "Una manera de verse cara a cara sin salir de tu casa.",
      "Videollamadas",
      "Viví la experiencia de Bumble directamente desde tu navegador.",
      "Aplicación web",
      "Nuestros líderes ayudan a traer los valores de Bumble a sus comunidades en todo el país.",
      "Líderes de la comunidad",
      "Funciones diseñadas para ayudarte a encontrar a quien quieras y compartir lo que te gusta.",
      "Organizá un encuentro grupal o descubrí eventos locales por tu zona.",
      "Plans",
      "Explorar BFF",
      "Todos los consejos y la inspiración que necesitás para encontrar al amor y conocer nuevas amistades.",
      "Consejos e historias para ayudarte a tener las amistades que querés.",
      "Momento para la amistad",
      "Desde Tokio hasta Toronto, conocé las historias de amor que nacieron en Bumble alrededor del mundo.",
      "Historias de amor",
      "Planificá la cita perfecta: donde quieras, cuando quieras, con quien quieras.",
      "Tips de citas según el momento",
      "Explorar la sección Historias",
      "Ir al contenido principal",
      "Logotipo de Bumble",
      "Cerrá el menú de navegación",
      "Abrí el menú de navegación",
      "Retrato de Whitney Wolfe Herd, fundadora y directora ejecutiva de Bumble",
      "Whitney Wolfe Herd fundó Bumble con un objetivo: generar un espacio más confiable para encontrar el amor, donde las mujeres dieran el primer paso y la conexión se base en el respeto.{{__EOL__}}{{__EOL__}} Como CEO, aún lidera con la misma convicción: encontrar el amor en línea debe ser proyectado, seguro y auténtico. Bumble no se trata de una simple app de citas. Se trata de ayudar a las personas a encontrar lo que importa, con cuidado, intención y corazón. Eso significa utilizar la tecnología y la IA para profundizar la conexión humana, no reemplazarla. Estamos utilizando todo lo que hemos aprendido: lo bueno, lo imperfecto y lo honesto, para que toda nuestra comunidad siga sintiéndose bienvenida en Bumble.",
      "Whitney Wolfe Herd",
      "Pareja sonriente inclinándose par darse un beso y tomándose de las manos en el asiento trasero de un auto, con vegetación afuera.",
      "Creemos que el amor, en todas sus formas, es la base de una vida feliz y saludable.",
      "Hola. Somos la Compañía del amor.",
      "vista de una conexión de Bumble con dos perfiles y una datita para iniciar la conversación.",
      "¿El resultado? Una plataforma que prioriza a las personas diseñada para crear conexiones profundas y sanas.",
      "En el {{date}}, redefinimos las reglas de las citas.",
      "Nuestra misión es acercar a las personas al amor.",
      "Nuestra misión",
      "Invertimos las normas de las citas y las mujeres empezaron a dar el primer paso.",
      "¡Nació Bumble!",
      "Se lanzó {{bff}} para ayudar a la gente a rodearse de buenas amistades, porque la vida es mejor con amigos.",
      "No fueron solo citas",
      "Serena Williams nos ayudó a llevar a las mujeres que dan el primer paso al Super Bowl.",
      "Apertura del Super Bowl",
      "Lanzamos nuevas funciones para tener citas durante la pandemia de covid-19.",
      "Las citas se volvieron virtuales",
      "Entramos a la bolsa, liderados por la mujer más joven que lo haya hecho antes.",
      "Hicimos historia",
      "Junto con nuestra tecnología cibernética de antiacoso, ampliamos nuestras políticas para proteger a las mujeres.",
      "Mejoramos la seguridad",
      "Pusimos el foco en los deportes femeninos como se lo merecían.",
      "WNBA x Bumble",
      "Ahora, estamos construyendo un futuro en el que el amor es posible para todo el mundo.",
      "Lideramos con amor",
      "Comenzamos con una movida audaz. Hoy, estamos construyendo el espacio más confiable y eficaz para encontrar el amor.",
      "Desplazate para explorar",
      "Desplazá a la izquierda",
      "Desplazá a la derecha",
      "Nuestra historia",
      "Ver puestos disponibles",
      "Ayudanos a construir el lugar más confiable para encontrar el amor.",
      "Trabajá con nuestro equipo",
      "vista del perfil de usuario e Insignias de intereses para conectarse con amistades en la aplicación BFF",
      "Ya sea que te hayas mudado a una nueva ciudad o simplemente quieras ampliar tu círculo social, {{bff}} te ayuda a encontrar fácilmente personas con los mismos gustos que vos.",
      "Encontrar personas",
      "Collage de perfiles de Bumble que muestran a personas diversas con insignias de perfil verificado, incluida una imagen en el centro de una mujer que se saca una selfi en un espejo.",
      "Ya sea que sean tus primeras citas o estés volviendo al ruedo, Bumble Date está diseñado para acercarte al amor de manera segura y significativa.",
      "Encontrar a tu conexión",
      "Mujer sonriente llevando una tabla de skateboard en un parque",
      "Naturaleza",
      "Hombre trotando y sonriendo en un parque por la ciudad",
      "Correr",
      "Mujer sosteniendo un pequeño perro peludo al aire libre",
      "Mascotas",
      "Descargar Bumble",
      "Queremos que nuestros miembros encuentren relaciones significativas y auténticas que generen confianza y alegría.",
      "Existimos para acercar a las personas al amor.",
      "Mujer con el cabello largo y oscuro recogido alto, musculosa negra y gafas de sol en la cabeza, sonriendo con el mar detrás de ella.",
      "Hombre con barba y camisa a rayas que sostiene una cámara, de pie al aire libre con árboles y edificios de fondo.",
      "Mujer con campera roja de arcoíris a rayas y auriculares plateados, usando un collar de estrella verde, mirando a la cámara.",
      "Pareja sonriente abrazándose en un retrato en blanco y negro",
      "{{name1}} y {{name2}}, casados en {{num}}",
      "¡Enterate!",
      "Leer más historias",
      "\"{{__EOL__}}Ambos somos de naturaleza positiva, que vamos para adelante, pero cuando nos juntamos, parece que no hay nada que no podamos lograr.",
      "Dos personas riendo en una cancha de tenis; una se tapa los ojos con pelotas de tenis",
      "Conocerse en persona",
      "Los eventos presenciales de Bumble significan que podés dejar de escribir y empezar a charlar. Vení sin compañía o con amistades, y terminá el evento con una nueva conexión.",
      "Empezá la charla en persona",
      "Personas disfrutando de conexiones en Bumble a través de fotos, videochats y asesoramiento de expertos.",
      "Registrarse",
      "Ayudá a dar forma al futuro de Bumble; para eso, unite a nuestro Círculo de Miembros. Esta comunidad especial de miembros comparte ideas directamente con nuestro equipo a través de chats, discusiones y pruebas de productos.{{__EOL__}}{{__EOL__}}Los participantes obtienen acceso anticipado a nuevas funciones, conocen futuras campañas y tienen la oportunidad de ayudar a que Bumble sea aún mejor para todos.",
      "Compartí tus ideas",
      "¿Te da curiosidad? Probá hacer una videollamada en Bumble para conocer a tu próxima cita.",
      "Simplemente, toca el ícono de video en tu chat para iniciar una videollamada, sin compartir ninguna información de contacto personal.",
      "¿Cómo funciona la videollamada en Bumble?",
      "No. Todas las llamadas y chats en Bumble mantienen tu información personal segura y protegida. No obtendrá tu número ni ningún otro detalle de contacto hasta que vos se lo digas.",
      "¿Mi cita va a ver mi número de teléfono?",
      "¡Absolutamente! Si todavía no estás listo para verte en persona, las llamadas de voz te permiten conectarte a través del audio. Solo tenés que seleccionar el icono de llamada.",
      "¿Puedo probar solamente una videollamada?",
      "Nos encanta recibir notificaciones nuevas. Pero sabemos que es difícil saber si tus conversaciones van a ser tan buenas como en persona. Para eso, tenemos las videollamadas y las llamadas de audio.",
      "Videollamada en Bumble",
      "<a href={{video_chat_url}}>Las videollamadas y las llamadas de audio</a> pueden ayudarte a conocerse y a decidir si querés avanzar fuera de la aplicación. Lo mejor de todo es que cuando hacés una llamada a través de Bumble, no tenés que intercambiar números de teléfono, por lo que tu información personal permanece segura hasta que estés listo para compartirla.",
      "Comprobá si hay química con una videollamada",
      "Conocé mejor a tu cita por video antes de decidir si es hora de dar el salto y reunirte en persona.",
      "Conocé mejor a tu cita (y más rápido). Una conversación cara a cara o una charla por teléfono te permite saber mucho más del otro.",
      "Vos tenés el control. Mantenemos tus datos de contacto en privado para que puedas elegir cuándo compartirlos.",
      "Descubrí si llegó la hora de conocer a tu cita en persona",
      "Detectá en el momento si hay onda",
      "Conectate sin brindar información personal",
      "¿Por qué deberías usar llamadas y videollamadas?",
      "¿Sentís que es hora de iniciar una conversación? Podés elegir comenzar una videollamada o una llamada de audio directamente desde el chat de Bumble. Para iniciar una videollamada, tocá el icono de la cámara de video gris en la esquina superior derecha. También vas a ver tres puntos junto al icono, en el que tenés que hacer clic y vas a ver también la opción de videollamada.",
      "Cómo hacer videollamadas",
      "¿Todo listo para probar Compliments?",
      "Cuando enviás un Compliment, la persona que lo recibe lo verá cuando aparezcas en su lista.",
      "¿Qué pasa cuando le enviás un Compliment a alguien en Bumble?",
      "Si te llamó la atención el Compliment de alguien, animate y conectá. Vas a ver el Compliment en tu chat, y se aplican las reglas habituales de <a href={{make_the_first_move_url}}>Dar el primer paso</a>.",
      "¿Cómo respondo a un Compliment?",
      "Podés enviar {{num}} [[Compliments:num]] de forma gratuita. Cuando no te queden más, podés comprar en la aplicación Bumble en paquetes de hasta 30. Uno de esos se utilizará para enviar ese Compliment (guardá el resto para cuando veas otro perfil que te guste). No te preocupes, no se vencen.",
      "¿Cuántos Compliments puedo enviar?",
      "Unas lindas palabras pueden lograr muchas cosas. Si querés enviar un Compliment, pero no te salen las palabras indicadas, probá estas frases para inspirarte:",
      "Ver más ejemplos",
      "“A cualquiera que le guste [nombre de artista], tiene buen gusto”.",
      "“¡Tu sonrisa es contagiosa!”",
      "“Tu bio me causó mucha gracia. Muy original”.",
      "Cómo enviar mejores cumplidos en Bumble",
      "¿Querés alegrarle el día a alguien? Entonces es hora de usar Compliments.",
      "Compliments en Bumble",
      "Usá Compliments en Bumble para que una posible conexión sepa que te gusta su perfil (e incluso hacerla sonrojar). Recibís Compliments como parte de tu membresía de {{service_level_lexeme_name}}. También es una forma de enviar y recibir mensajes antes de haber conectado.",
      "Cómo funciona la función de Compliments",
      "Cuando recibas un Compliment, va a aparecer en el perfil del remitente. También vas a recibir una notificación que te informará que a alguien le gusta parte de tu perfil.",
      "Descubrí tus Compliments",
      "Para enviar un Compliment, tocá el icono del corazón amarillo en la parte inferior del perfil de alguien. Es importante tener en cuenta dónde tocás, ya que vas a darle un cumplido a una foto específica o parte de su perfil. Cuando hagas clic, se va a abrir un cuadro de texto para que escribas tu mensaje (asegurate de que el contenido sea de hasta 150 caracteres).",
      "Enviá un Compliment",
      "DESCARGÁ Bumble Y PROBÁ LA FUNCIÓN DESCUBRÍ",
      "Todos los días, desde las 9:00 de la mañana, vas a ver gente nueva para vos en Descubrí. Podés conectarte con ellos por lo que tengan en común.",
      "¿Cuándo se actualiza la página Descubrí?",
      "Tu página Descubrí ordena posibles conexiones en 3 categorías principales: intereses similares, mismos objetivos de una cita y comunidades en común. Además, se muestran las recomendaciones de perfil, según las conexiones anteriores.",
      "¿Cómo funciona la selección de mi página Descubrí?",
      "Una página personalizada que destaca a las personas más compatibles con vos, actualizada todos los días",
      "ENCONTRÁ GENTE QUE ESTÉ EN LA MISMA CON DESCUBRÍ {{qr_code}}",
      "La función Descubrí te muestra una selección de personas que podrían gustarte, según intereses, objetivos de citas y comunidades en común.",
      "Probar Descubrí",
      "¿ESTÁS BUSCANDO UNA NUEVA FORMA DE CONECTAR CON LO QUE TE UNE?",
      "La página DescubrÍ se actualiza todos los días, para mostrarte aún más personas con las que serías compatible para que puedas pasar menos tiempo buscando una conexión, y más tiempo conociendo a la persona con la que tendrás química.",
      "RECOMENDACIONES ACTUALIZADAS TODOS LOS DÍAS",
      "Las recomendaciones de Descubrí se basan en tu perfil y en las personas con las que conectaste. Por eso, vas a ver personas que les gustan y quieren lo mismo que vos; ya sea comida vegana o una relación a largo plazo.",
      "CONEXIONES{{__EOL__}}A TU MEDIDA",
      "Descargar Bumble",
      "Preguntas frecuentes",
      "¿Todo listo para navegar por Bumble en privacidad?",
      "Cuando activás el Modo Incógnito, no aparecés para otros miembros de Bumble, a menos que le des me gusta a su perfil.",
      "¿Cómo funciona el Modo Incógnito?",
      "Sin el Modo Incógnito, tu perfil es visible para otras personas en Bumble cuando tenés sus mismas preferencias, como la edad y la ubicación. Cuando activás el Modo Incógnito, solo te van a ver las personas una vez que les hayas dado me gusta.",
      "¿Quién puede verme en el Modo Incógnito de Bumble?",
      "Usar el Modo Incógnito no es lo mismo que <a href={{blocking_on_bumble_url}}>bloquear a alguien en Bumble</a>. Con esta función, si te gusta alguien (o si le enviaste un mensaje en el pasado), va a poder ver tu perfil.",
      "¿El Modo Incógnito es como bloquear a alguien?",
      "Controlá quién mira tu perfil con el Modo Incógnito de Bumble.",
      "Modo Incógnito en Bumble",
      "Si querés salir del mundo de las citas o navegar por Bumble sin que otras personas vean tu perfil, podés activar el Modo Incógnito. Con esta función, ocultaremos tu perfil a todos, a menos que te guste primero un perfil. Esto te permite controlar lo que compartís y quién te ve.",
      "Ocultá tu perfil con el Modo Incógnito",
      "Vos decidís quién puede ver tus fotos y tu información personal.",
      "¿Querés incluir algo personal en tu perfil? Podés compartir discretamente lo que quieras con tus conexiones actuales.",
      "Navegá libremente sin preocuparte por encontrarte con un ex, un compañero de trabajo o cualquier otra persona que no esté en tu radar de citas.",
      "Tomá todo el control",
      "Elegí qué compartir",
      "Evitá encuentros incómodos",
      "¿Por qué el Modo Incógnito es para vos?",
      "El Modo Incógnito está disponible para los miembros de {{service_level_lexeme_name}} y {{service_level_lexeme_name_two}}. Después de que te hayas registrado, podés activarlo desde la pestaña de tu perfil, para eso, tocá Configuración en la esquina superior derecha y cambiá a Modo Incógnito.",
      "Pasate a {{service_level_lexeme_name}}",
      "Cómo usar el Modo Incógnito en Bumble",
      "DESCARGÁ Bumble Y PROBÁ LA FUNCIÓN CONEXIÓN INMEDIATA",
      "En la app Bumble, andá al icono del Perfil en la parte inferior de la pantalla. Ahí vas a encontrar el icono del código QR, en la parte superior derecha de la pantalla, que vas a tocar para acceder.",
      "¿Dónde puedo encontrar mi código QR personal?",
      "¡No hace falta! Tenés que estar conectado a Internet, ya sea a través de datos móviles o wifi, y usar el código QR en vivo actual de Conexión inmediata para que funcione.",
      "¿Puedo hacer una captura de pantalla de mi código QR para compartir?",
      "No es necesario. Si una persona escanea el código, vas a tener una conexión automáticamente.",
      "¿Ambas personas necesitan escanear el código QR?",
      "Con la Conexión inmediata, podés ver automáticamente lo que vos y tu nueva conexión tienen en común, lo que te da una idea de su compatibilidad desde el principio.",
      "ENCONTREMOS LO QUE NOS UNE",
      "¿Empezaste la conversación en persona en un evento de Bumble? Seguí disfrutando de la app.",
      "TRANSFORMÁ UN ENCUENTRO ÚNICO EN UNA CONEXIÓN INMEDIATA {{qr_code}}",
      "La Conexión inmediata simplifica la transición de un encuentro único a un \"sigamos hablando\" sin tener que intercambiar números ni perfiles sociales. Simplemente escanéa tu código QR para conectar con alguien en Bumble.",
      "Probá Conexión inmediata",
      "¿CONOCISTE A ALGUIEN EN UN EVENTO DE Bumble?",
      "En lugar de intercambiar perfiles sociales o números de teléfono, la Conexión inmediata te permite saber si primero hay química. De esta manera, pueden conocerse mejor a su propio ritmo, gracias a las funciones de seguridad de Bumble.",
      "UNA FORMA MÁS SEGURA DE CONECTAR",
      "Después de conocerse en persona en un evento de Bumble, descubran si hay química con una charla en la app y conéctense según lo que tengan en común, ya sea el amor por el café perfecto o el cuidado de las suculentas.",
      "CONÓZCANSE MÁS",
      "¿Querés tomarte un descanso? Probá el Modo No Molestar.",
      "Sí, podés ir a tu configuración o tu fila y desactivar el Modo No Molestar en cualquier momento.",
      "¿Puedo desactivar el Modo No Molestar anticipadamente?",
      "Tenés que ir a tu configuración, tocar No Molestar y elegir por cuánto tiempo querés estar ausente. Podés volver cuando creas que es el momento.",
      "¿Cómo uso el Modo No Molestar en mi perfil?",
      "No. Mientras estés en el Modo No Molestar, toda la actividad de deslizar y chatear está pausada. Si vas para ver nuevas personas, vas a ver un mensaje que te dice cuánto tiempo durará el Modo No Molestar, con la opción de desactivarlo.",
      "¿Puedo seguir viendo perfiles y chateando en el Modo No Molestar?",
      "Las personas a las que ya les hayas enviado un mensaje van a ver tu estado 'Ausente' (si decidís configurarlo). De lo contrario, van a ver tus mensajes anteriores en su Bandeja de entrada como de costumbre.",
      "¿Qué verán las conexiones actuales cuando estés en el Modo No Molestar?",
      "Tenés todo el control sobre tu actividad en Bumble, y podés alejarte de la plataforma en cualquier momento.",
      "Podés mantener al tanto a tus conexiones existentes con la actualización de tu estado, para que no parezca que <a href={{ghosted_article_url}}>ghosteaste</a>. Además, como todo es automático, no necesitás enviar ningún mensaje.",
      "Tomate un descanso de la búsqueda activa de una pareja sin perder tus conexiones ni chats.",
      "Salí con alguien (o desconectate) según tus reglas",
      "Mantené al tanto a tus conexiones",
      "Poné en pausa tu actividad, pero no tus conexiones",
      "¿Por qué amamos el Modo No molestar?",
      "Abrí la app de Bumble, andá a la pestaña de tu perfil y tocá el engranaje en la esquina superior derecha. En Configuración, tocá el Modo No Molestar y elegí cuánto tiempo querés ausentarte. Podés ocultar tu perfil durante 24 horas, 72 horas, una semana o indefinidamente.{{__EOL__}}{{__EOL__}}Recordá que las conexiones sin conversaciones activas expirarán mientras estés en Modo No Molestar. Si decidís poner un estado, las personas con las que estás actualmente conversando podrán ver que estás ausente.",
      "¿Cómo funciona el Modo No Molestar en Bumble?",
      "Cuando tenés una vida agitada, el Modo No Molestar llega para ayudarte. Poné en pausa tu cuenta de Bumble, y salí con gente cuando vos quieras.",
      "Modo No Molestar en Bumble",
      "El Modo No Molestar es una forma fácil de poner en pausa tu cuenta cuando querés tomar un respiro de las citas. De todos modos, podés seguir chateando con las conexiones que ya tenés, solo que oculta tu perfil a otras personas hasta que tengas todo listo para volver al ruedo. Cuando activás el Modo No Molestar, no perdés tu información de perfil ni eliminás las conexiones existentes.",
      "Ocultá tu perfil de Bumble",
      "Cuando estés en Modo No Molestar, actualizá tu estado para que tus conexiones existentes sepan que estás descansando. Elegí entre 'Estoy de viaje', 'Foco en el trabajo', 'Estoy de detox digital' o 'Me priorizo a mí'. Cualquiera sea tu vibra, nosotros estamos para vos.",
      "Agregá un estado cuando no estés",
      "Activar el Modo No Molestar pone en pausa tu cuenta de Bumble (o {{page_partner_name_bff}}). Tus conexiones no sabrán que estás en Modo No Molestar, a menos que se los digas. Si decidís desactivar el Modo No Molestar antes del plazo que elegiste inicialmente, solo tenés que volver a Configuración y tocar “Desactivar Modo No Molestar”. ¡Es muy simple!",
      "Poné en pausa tus chats",
      "Probá SuperSwipe en Bumble",
      "¡Todos los que quieras! Los usuarios de {{service_level_lexeme_name}} obtienen {{num}} [[superswipe:num]] cada semana, pero podés recargar más en cualquier momento. Los miembros gratuitos pueden comprar paquetes de SuperSwipes.",
      "¿Cuántos SuperSwipes puedo enviar en Bumble?",
      "Después de que alguien te haya dado un SuperSwipe en tu perfil, vas a recibir una notificación de inmediato. También vas a ver una etiqueta sobre el nombre de esa persona en su perfil, que indica que le gustás.",
      "¿Cómo sé si alguien me dio un SuperSwipe?",
      "¿Te pasan cosas con alguien? Animate y enviale un SuperSwipe para que sepa que le interesás y lleguen a una buena charla sin vueltas.",
      "SuperSwipe en Bumble",
      "Destacarse de los demás no siempre es fácil, pero con SuperSwipe podés causar una primera buena impresión.{{__EOL__}}{{__EOL__}}Cuando usás un SuperSwipe, se enviará una notificación a la persona a la que le gustaste. De este modo, aparecés al principio de su lista con una etiqueta en tu perfil. Si también le gustás, es hora de empezar a chatear.",
      "¿Qué es un SuperSwipe?",
      "Animarte a más y destacarte",
      "Empezar más chats",
      "Hacer más conexiones",
      "Con SuperSwipe vas a poder…",
      "Si tenés <a href={{bumble_boost_url}}>Bumble {{service_level_lexeme_name}}</a> o Bumble {{service_level_lexeme_name_one}}, obtenés {{num}} [[superswipe:num]] gratis por semana. Además, todos los miembros pueden comprar paquetes de hasta {{num_two}} [[superswipe:num_two]] en la pestaña del perfil. Si tenés {{service_level_lexeme_name_three}}, vas a obtener {{num_three}} [[superswipe:num_three]] por semana.{{__EOL__}}{{__EOL__}}Usar SuperSwipe es fácil: cuando veas a alguien que te guste, simplemente tocá el icono de la estrella amarilla en la parte inferior de tu perfil.",
      "Cómo usar SuperSwipe",
      "Salí con alguien con el Modo Travel de Bumble",
      "Los miembros de <a href={{bumble_premium_url}}>{{service_level_lexeme_name}}</a> pueden usar el Modo Travel. Activalo y van a aparecer nuevas caras en la fila de la ciudad que elijas.",
      "¿Cómo uso el Modo Travel?",
      "Básicamente, tenemos algunas restricciones de seguridad que pueden cambiar con el tiempo, pero el Modo Travel está disponible para la mayoría de los destinos.",
      "¿Puedo usar el Modo Travel en cualquier lugar?",
      "El Modo Travel mostrará tu ubicación como el centro de la ciudad elegida, así te van a encontrar nuevas conexiones en el área. Las personas verán en tu perfil una nota que dice que estás en Modo Travel, para que sepan que estás visitando, o planeando visitar ese lugar.",
      "¿Estás por irte de vacaciones o yendo a una nueva ciudad por trabajo? Activá el Modo Travel de Bumble para tener citas en cualquier parte del mundo.",
      "Modo Travel en Bumble",
      "El Modo Travel es tu herramienta definitiva para hacer conexiones mientras estás afuera. Configurá tu ubicación en cualquier parte del mundo, y tu perfil aparecerá como si estuvieras en la ciudad que elijas. Esto significa que podés tener una citas en dondequiera que te lleven tus aventuras.",
      "¿Qué es el Modo Travel?",
      "Nadie conoce mejor un lugar que los locales. El Modo Travel puede ayudarte a conectarte con las personas que harán que tu viaje sea aún más especial.",
      "Configurá tu ubicación en la ciudad hasta siete días antes de visitarla, para que puedas planificar citas y conocer conexiones con anticipación.",
      "Además de pasear por la playa, podrías estar en casa durante las vacaciones, viajando por trabajo o explorando una nueva ciudad. Encontrá el amor donde aterrices.",
      "Encontrar los mejores lugares para una cita local",
      "Tener una aventura",
      "Tener vínculos duraderos",
      "Razones por las que el Modo Travel te va a encantar",
      "El Modo Travel está disponible para los miembros de <a href={{bumble_premium_url}}>{{service_level_lexeme_name}} y {{service_level_lexeme_name_two}}</a> en Bumble. Tocá en el engranaje de Configuración en la parte superior derecha de tu perfil y desplazate hasta que veas el Modo Travel. Elegí tu nueva ubicación para comenzar a ver personas en esa área. En tu perfil, podrán saber que estás en Modo Travel.",
      "¿Cómo funciona el Modo Travel?",
      "Probar ahora",
      "Acá seducís con tu gentileza, podés ser como realmente sos, y las mujeres siempre tienen la iniciativa.",
      "La confianza de poder dar el primer paso™",
      "Las relaciones sanas son fundamentales para llevar una vida productiva y positiva. El objetivo de Bumble es lograr que te empoderes mientras conocés gente nueva, ya sea en una cita, en una salida para hacer nuevas amistades o simplemente para ampliar tu red de contactos profesional.",
      "Por qué Bumble es diferente",
      "Defendemos la integridad, amabilidad, igualdad, confianza y respeto durante todas las etapas de cualquier relación. No solo damos la bienvenida, sino que también celebramos cualquier orientación sexual, ya sea que estés buscando pareja o simplemente quieras pasar un buen momento.",
      "Qué valoramos en Bumble",
      "En Bumble, las mujeres tienen la palabra, ya que son las que dan el primer paso o permiten iniciar la conversación con una Opening Move. Empezá a relacionarte priorizando la igualdad y olvidate de las dinámicas de poder antiguas.",
      "Cómo funciona Bumble",
      "Sobre nosotros",
      "Descargar ahora",
      "En la app todo es mejor.",
      "Funciones diseñadas para pasar un buen momento en las citas en línea",
      "12 de febrero, 2024",
      "Cómo crear más intimidad emocional en tu relación",
      "25 de enero, 2024",
      "Cómo usar Bumble cuando nunca usaste una app de citas",
      "5 de febrero, 2024",
      "Deception Detector™",
      "Todo lo que necesitás saber sobre citas",
      "Usa el <b>Modo no molestar</b> para tomarte un tiempo. Cuando quieras volver a conocer gente nueva, te esperamos.",
      "Tomate un descanso",
      "Usá <b>videollamadas</b> y <b>audiochats</b> para estar más cerca que nunca de tu conexión sin salir de tu casa.",
      "Decilo a los cuatro vientos",
      "Ver más",
      "Usá la opción <b>Opening Moves</b> para que tu conexión te empiece a escribir antes que vos.",
      "Menos es más",
      "Encontrá lo que te hace feliz en cualquier lugar del mundo y conectá con gente de todas partes con el <b>Modo Travel</b>.",
      "Llevanos con vos",
      "Si te gustó mucho un perfil, dejá que se sepa gracias a <b>SuperSwipe</b>.",
      "Llamá su atención",
      "Sorprendé con tus <b>Compliments</b> y marcá la diferencia.",
      "Regalá una sonrisa",
      "Usá el <b>Modo Incógnito</b> para ocultar tu perfil de tu jefe, familiares o exparejas.",
      "Usá la discreción",
      "Relacionate como quieras",
      "Unos meses después, ella también conoció a su dama de honor",
      "Ana conoció a su actual marido en Bumble.",
      "Antes de que se hicieran la casa juntos, Carina y Javier se conocieron en Bumble. En ese momento, Javier se enamoró cuando vio las fotos de los viajes de Carina.",
      "Carina y Javier",
      "Bauti y Camila trabajaban en la misma ciudad en el exterior, pero se conocieron en Bumble",
      "Bauti y Camila",
      "Si funcionó para otras personas, podría funcionar para vos",
      "Da el próximo paso",
      "Ver las novedades",
      "Como te merecés lo mejor, diseñamos nuevas maneras de conocer más gente en un entorno más relajado.",
      "Encontrá lo que te merecés",
      "Acerca de Bumble",
      "Esta es única aplicación que pone la experiencia de las mujeres en primer lugar para mejorar la experiencia de las citas. Porque un mundo mejor para las mujeres es un lugar mejor para todo el mundo.",
      "Make the first move™",
      "Encontrá a alguien que realmente quieras conocer y animate a dar el primer paso. Conectá genuinamente, dejate llevar por lo que sentís y, sobre todo, pasala bien.",
      "Conocé gente con Bumble Date",
      "Conocé amistades con beneficios laborales. Conectá con otros profesionales para encontrar tu próximo trabajo, mentoría o incluso cambiar tu carrera profesional.",
      "Conectá con profesionales gracias a Bumble Bizz",
      "Conocé gente distinta o que esté en la misma que vos. Generá nuevas amistades para compartir nuevas experiencias.",
      "Encontrá nuevas amistades en Bumble For Friends",
      "No es solo una app de citas",
      "Bumble es la app de citas en la que las mujeres dan el primer paso. Es la app que revolucionó la manera de tener citas, y fomentar relaciones y conexiones reales. Descargala ahora.",
      "Bumble en {{social_network}}",
      "Más información",
      "Descargá Bumble desde App Store o Google Play y registrate con la misma cuenta que usaste en Bumble web.{{__EOL__}}{{__EOL__}}Escaneá el siguiente código QR con tu teléfono o tableta para comenzar.{{__EOL__}}{{__EOL__}}Tus conexiones y conversaciones te están esperando en la app. 💛",
      "Descargá la aplicación",
      "Para que podamos seguir brindándote la mejor experiencia y funciones de seguridad, Bumble ahora está disponible solo como aplicación.",
      "Bumble ahora es solo una aplicación.",
      "No te pierdas nunca más una conexión",
      "Llamá sin que sepan tu número",
      "Confiá en que tus conexiones sean genuinas.",
      "Activá las notificaciones en tiempo real para no perderte ni un mensaje.",
      "Usá nuestras llamadas de voz y video en la aplicación para encontrarte en persona con tus conexiones, de manera segura.",
      "Chateá con seguridad con miembros verificados usando la verificación fácil de fotos e ID en la aplicación.",
      "¿Por qué cambiarse a la aplicación Bumble?",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life",
      "Premium+",
      "Lo sentimos, pero no pudimos encontrar la página que estabas buscando.",
      "Contacto",
      "Parece que algo falló...",
      "(se abre en otra ventana)",
      "Preguntas",
      "Política de cookies",
      "Premium",
      "Bumble - El Blog",
      "Empleos",
      "Chat",
      "Ciudades",
      "Gestionar cookies",
      "Copyright © 2006 – presente. Bumble. Todos los derechos reservados.",
      "Informe de confianza para citas",
      "Apple y el logotipo de Apple son marcas comerciales de Apple Inc. {{__EOL__}}Google Play es una marca de Google LLC.",
      "Descargar",
      "Facebook",
      "Seguinos",
      "Centro de Soporte",
      "Instagram",
      "Idioma",
      "LinkedIn",
      "Bumble es parte de Bumble Inc.",
      "Política de privacidad",
      "Centro de Seguridad",
      "Mapa del sitio",
      "Declaración sobre la Ley de Esclavitud Moderna",
      "Términos y condiciones",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "Compliments": {
            "plural": [
                  "Cumplidos"
            ],
            "singular": [
                  "Cumplido"
            ]
      },
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "superswipe": {
            "plural": [
                  "SuperSwipes"
            ],
            "singular": [
                  "SuperSwipe"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
